import { render, staticRenderFns } from "./email-summary.vue?vue&type=template&id=41dc2630&scoped=true"
import script from "./email-summary.vue?vue&type=script&lang=js"
export * from "./email-summary.vue?vue&type=script&lang=js"
import style0 from "./email-summary.vue?vue&type=style&index=0&id=41dc2630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dc2630",
  null
  
)

export default component.exports